// src/components/overview/WaitList.tsx
import { motion, Variants } from "framer-motion";
// import { Instagram, Twitter, Linkedin } from "lucide-react";
import "../../styles/pages/overview/waitList.css";
import { useAuth } from "../../providers/AuthProvider";
import { webappUrl } from "../../config/webapp";

const itemVariants: Variants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.3 },
  },
};

export default function WaitList() {
  const { isAuthenticated } = useAuth();

  return (
    <motion.div initial="hidden" animate="visible" variants={containerVariants}>
      <main className="wait-list-main-content">
        <motion.div variants={itemVariants}>
          {/* <WaitlistCount /> */}
          <h1 className="waitlist-pill-label">ORRA KINGDOM</h1>
        </motion.div>

        <motion.h1 variants={itemVariants} className="wait-list-hero-title">
          Stop Living in Scarcity
          <br />
          <span
            style={{
              fontFamily: "'Playfair Display', serif",
              fontStyle: "italic",
              fontWeight: "400",
            }}
          >
            Start Building in Abundance.
          </span>
        </motion.h1>

        <motion.p variants={itemVariants} className="wait-list-hero-subtitle">
          The first faith aligned platform that connects Christian
          entrepreneurs, professionals, and investors to create real wealth
          together.
          <br />
          <br />
        </motion.p>

        {/* <WaitlistForm /> */}
        {!isAuthenticated && (
          <div>
            <button
              onClick={() => {
                window.location.href = webappUrl("/register");
              }}
              className="cta-btn"
            >
              JOIN ORRA KINGDOM
            </button>
          </div>
        )}

        {/* <motion.div variants={itemVariants} className="wait-list-social-pill">
          <a href="#!" target="_blank">
            <Instagram size={18} />
          </a>
          <a href="#!" target="_blank">
            <Twitter size={18} />
          </a>
          <a href="#!" target="_blank">
            <Linkedin size={18} />
          </a>
        </motion.div> */}
      </main>
    </motion.div>
  );
}
